module.exports = __webpack_public_path__ + "img/rating-page-slider-desktop-6.a964795b.png";